import { ReceiveMessage } from '@/features/messages/models/message-receive';

import { HUB_EVENTS, hubEmitter } from '@/core/realtime';
import { useAuthStore } from '@/features/auth';
import { useActionStackStore } from '@/features/message-list/stores/action-stack';
import { useEffect } from 'react';

export type MessageReceiveEvent = ReceiveMessage;

export const useMessageReceiveEvent = () => {
  const { user } = useAuthStore();
  const { dispatchAction, pageSize } = useActionStackStore();

  useEffect(() => {
    const handleMessageReceived = async (newMsg: MessageReceiveEvent) => {
      if (newMsg.senderId === user?.user_id) return;
      const msg = new ReceiveMessage(newMsg).toMessage();
      const { conversationId } = msg;

      if (!conversationId) {
        console.warn('SignalR: Received message without conversationId');
        return;
      }

      // Only handle message insertion and scrolling
      // Read marker tracking is handled in message-list component
      dispatchAction({ type: 'insertMessage', conversationId, message: msg });
      dispatchAction({ type: 'scrollToBottom', conversationId });
    };

    hubEmitter.on(HUB_EVENTS.MESSAGE.RECEIVED, handleMessageReceived);
    return () => {
      hubEmitter.off(HUB_EVENTS.MESSAGE.RECEIVED, handleMessageReceived);
    };
  }, [user?.user_id, dispatchAction, pageSize]);
};
